export default {
  informacao_global: [],
  token: "",
  maintenanceMode: false,
  user: [],
  dadosPedido: {},
  campanhaStatus: [],
  campanhasDisponiveis: [],
  campanhasFiltros: [],
  productsWithCampanha: [],
  hasMoreCampaignsToShow: true,
  loadingCartPromotions: true,

  loadingHubPromotions: false,

  loadingCartCoupon: false,
  responseApplyCoupon: {
    success: false,
    message: null,
  },

  cartGifts: [],
  hubPromotions: [],
  hubPromotionsCounters: {
    acquired: 0,
    partial: 0,
    notAcquired: 0,
  },
  carrinhoAtual: [],
  paymentData: {
    card: {
      cardName: "",
      cardNumber: "",
      cardCvv: "",
      cardMonth: "",
      cardYear: "",
      saveCard: true,
      cardParcels: "",
      cardBrand: "",
      cardDocument: "",
    },
  },
  saveCards: [],
  totalProduct: 0,
  faturamentoData: {},
  savedCardSelected: {},
  cvvCardSave: "",
  globalAppLoading: false,
  cardPaymentError: {
    error: false,
  },
  usuarioInfo: {},
  clienteAtual: "",
  isAuthenticated: false,
  userShouldResetPassword: false,
  showLoadingModal: false,
  loadingModalIds: [],
  isDpcMobileWebView: navigator.userAgent.includes("dpc-mobile-webview"),
  siteConfig: null,
};
